import {ModalProgrammatic as Modal} from 'buefy';
import EditUser from "./components/editUser";

function editAccountType(id, callback = null) {
    const modal = Modal.open({
        canCancel: ["escape", "x"],
        component: EditUser,
        events: {
            onSave(user) {
                modal.close();
                if (callback) {
                    callback(user);
                }
            }
        },
        props: {
            id,
            action: 'edit'
        }
    });
}

export default {
    editAccountType
}